import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_SKIP_OWF_UPSELL_250409 } from "@faire/retailer-settings/FE_SKIP_OWF_UPSELL_250409";

export const useSettingSkipOwFUpsell = () => {
  return useSetting(FE_SKIP_OWF_UPSELL_250409);
};

export const useAssignSettingSkipOwFUpsell = () => {
  return useAssignSetting(FE_SKIP_OWF_UPSELL_250409);
};
